import { render, staticRenderFns } from "./BaseCheckboxSwitch.vue?vue&type=template&id=1191bff2&scoped=true"
import script from "./BaseCheckboxSwitch.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1191bff2",
  null
  
)

export default component.exports